import { Alert, AlertColor, Snackbar } from "@mui/material";

const autoHideBySeverity: Record<AlertColor, number> = {
  success: 4000,
  info: 6000,
  warning: 8000,
  error: 12000,
};

type FeedbackSnackbarProps = {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
};

export const FeedbackSnackbar = ({
  open,
  message,
  severity,
  onClose,
}: FeedbackSnackbarProps) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideBySeverity[severity]}
    onClose={(_, reason) => {
      if (reason !== "clickaway") onClose();
    }}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      variant="filled"
      role={severity === "error" ? "alert" : "status"}
      aria-live={severity === "error" ? "assertive" : "polite"}
      sx={{
        width: { xs: "calc(100vw - 32px)", sm: 440 },
        maxWidth: "100%",
        boxShadow: 8,
      }}
    >
      {message}
    </Alert>
  </Snackbar>
);
